module.exports = require("https-proxy-agent");